module.exports = __webpack_public_path__ + "img/icon_hy.bc141d7b.png";